export default __webpack_public_path__ + "static/media/docLogo.1e8b6989.svg";